import { render, staticRenderFns } from "./OfficialFeeForm.vue?vue&type=template&id=41087e66&"
import script from "./OfficialFeeForm.vue?vue&type=script&lang=js&"
export * from "./OfficialFeeForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficialFeeForm.vue?vue&type=style&index=0&id=41087e66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports